// Pure resolver: effect → targetgroups + research IDs per targetgroup.
//
// The effect conceptually pairs to targetgroups through activities, but what
// we actually filter by is ResearchID — and each Research already carries one
// TargetgroupID and one QuestionnaireID (ADR-016). So we resolve by:
//   effect → QuestionnaireFields (array-contains EffectId) → QuestionnaireIDs
//   → Research docs with that QuestionnaireID → group by TargetgroupID
// This is data-driven: only targetgroups that actually have a research
// (and therefore potential responses) appear in the filter.

const resolveResearchIdsForEffect = ({
    effect,
    stakeholders,
    questionnaireFields,
    researches,
}) => {
    const empty = {
        targetgroups: [],
        researchIdsByTargetgroup: {},
        questionnaireIds: [],
        multipleQuestionnaires: false,
    }

    if (!effect || !effect.ID) return empty

    const stakeholderList = Array.isArray(stakeholders) ? stakeholders : []
    const fieldList = Array.isArray(questionnaireFields) ? questionnaireFields : []
    const researchList = Array.isArray(researches) ? researches : []

    const questionnaireIds = Array.from(
        new Set(
            fieldList
                .filter(
                    (f) =>
                        Array.isArray(f.EffectId) && f.EffectId.includes(effect.ID)
                )
                .map((f) => f.QuestionnaireID)
                .filter((id) => !!id)
        )
    )

    if (questionnaireIds.length === 0) {
        return { ...empty }
    }

    const stakeholderById = new Map(stakeholderList.map((s) => [s.ID, s]))

    const researchIdsByTargetgroup = {}
    researchList.forEach((r) => {
        if (!questionnaireIds.includes(r.QuestionnaireID)) return
        if (!r.TargetgroupID) return
        if (!researchIdsByTargetgroup[r.TargetgroupID]) {
            researchIdsByTargetgroup[r.TargetgroupID] = []
        }
        if (!researchIdsByTargetgroup[r.TargetgroupID].includes(r.ID)) {
            researchIdsByTargetgroup[r.TargetgroupID].push(r.ID)
        }
    })

    const targetgroups = Object.keys(researchIdsByTargetgroup)
        .map((id) => {
            const s = stakeholderById.get(id)
            return {
                ID: id,
                Organisation: s?.Organisation || 'Onbekende doelgroep',
            }
        })
        .sort((a, b) => a.Organisation.localeCompare(b.Organisation))

    return {
        targetgroups,
        researchIdsByTargetgroup,
        questionnaireIds,
        multipleQuestionnaires: questionnaireIds.length > 1,
    }
}

export default resolveResearchIdsForEffect
